import React, { useRef } from 'react';
import { Box, Button, Stack, Tab, Tabs } from '@curves/ui-base';

import { useCustomerResourceContext } from "@Local/CustomerResource/Components/CustomerResourceContext";
import { CustomerResourceAddDialogBox, CustomerResourceSortDialogBox } from '@Local/CustomerResource/Dialog/';
const CustomerResourceTabs = () => {
    const customerResourceTypeMap = [
        {
            label: '策略夥伴',
            value: 1,
        },
        // {
        //     label: '其他',
        //     value: 2,
        // },
    ];
    const { customerResourceType, setCustomerResourceType, addDialogRef, refresh } = useCustomerResourceContext();
    // 只為排序彈窗使用本地 ref
    const sortDialogRef = useRef(null);
    const handleChangeTabs = (_, val) => {
        if (typeof setCustomerResourceType === 'function') setCustomerResourceType(val);
    };
    const handleOpenCustomerResourceAddDialog = () => {
        if (addDialogRef.current && addDialogRef.current.openCustomerResourceDialog) {
            addDialogRef.current.openCustomerResourceDialog(null, refresh);
        }
    };
    const handleOpenCustomerResourceSortDialog = () => {
        if (sortDialogRef.current && sortDialogRef.current.openCustomerResourceSortDialog) {
            sortDialogRef.current.openCustomerResourceSortDialog(null, refresh);
        }
    };
    return (
        <Stack justifyContent={'space-between'} alignItems={'center'}>
            <Tabs value={customerResourceType} onChange={handleChangeTabs}>
                {customerResourceTypeMap.map((item) => (
                    <Tab key={item.value} className={'py-3'} label={item.label} value={item.value} />
                ))}
            </Tabs>
            <Box className="btn-group">
                <Button variant={'outlined'} onClick={handleOpenCustomerResourceSortDialog} color="primary">
                    排序
                </Button>
                <Button variant={'contained'} onClick={handleOpenCustomerResourceAddDialog} color="primary">
                    新增來源
                </Button>
            </Box>
            <CustomerResourceAddDialogBox ref={addDialogRef} />
            <CustomerResourceSortDialogBox ref={sortDialogRef} />
        </Stack>
    );
};
export default CustomerResourceTabs;
